import { connect } from 'react-redux';
import { useState, useEffect, useCallback, useRef } from 'react';

import { 
  GET_PROJECT_CONTRACTORS, SET_EDIT_CONTRACTORS_DIALOGUE_ID, SET_NEW_DAILY_REPORT_DIALOGUE_ID, DateStringMMDDYYYY, GET_DAILY_REPORT, SET_DELETE_DAILY_REPORT_DIALOGUE_ID,
  SET_EDIT_DAILY_REPORT_DIALOGUE_ID, REQUEST_UPLOAD_DAILY_REPORT_IMAGE, SiteboardApiValidator, ADD_DAILY_REPORT, DELETE_DAILY_REPORT,
} from '../actions/types';
import { siteboardAction } from '../actions/defaultActions';
import { keyCountInObject } from '../Util';
import PopupWindow from './PopupWindow';

import { isObject } from '../Util';

// icon imports
import Logo from '../SiteBoard_Logo';
import PrintIcon from '../icons/printIcon';
import EmailIcon from '../icons/emailIcon';
import MessagesIcon from '../icons/messagesIcon';
import DotsIcon from '../icons/dotsIcon';
import GlobeIcon from '../icons/globeIcon';
import AddIcon from '../icons/addIcon';
import NotepadIcon from '../icons/notepadIcon';
import ExportIcon from '../icons/exportIcon';
import SettingsIcon from '../icons/settingsIcon';
import EditIcon from '../icons/editIcon';
import TrashIcon from '../icons/trashIcon';

const EditDailyReportDialogue = ({ _userId, _projects, _subscriptions, _dailyReports, _dailyReportSummaries, _editDailyReportDialogueId, siteboardAction }) => {
  const uploadWorksiteImageInputRef = useRef(null);
  const [worksitePicturesData, setWorksitePicturesData] = useState([]);

  const getProjectId = useCallback(() => {
    if(_editDailyReportDialogueId in _dailyReports) return _dailyReports[_editDailyReportDialogueId].projectId;
    if(_editDailyReportDialogueId in _dailyReportSummaries) return _dailyReportSummaries[_editDailyReportDialogueId].projectId;
    return null;
  }, [_dailyReportSummaries, _editDailyReportDialogueId, _dailyReports]);;

  useEffect(() => {
    const selectedProject = _projects[getProjectId()];
    if(!selectedProject) return;

    const onSuccess = () => {};
    const onFailure = () => {};
    siteboardAction(GET_DAILY_REPORT, { projectId: selectedProject.id, dailyReportId: _editDailyReportDialogueId }, onSuccess, onFailure);
    siteboardAction(GET_PROJECT_CONTRACTORS, {projectId: selectedProject.id}); // Preemptively load contractor list
  }, [siteboardAction, _editDailyReportDialogueId, _projects, getProjectId]);

  const selectedProject = _projects[getProjectId()];
  const selectedSubscription = selectedProject ? _subscriptions[selectedProject.subscriptionId] : null;
  const selectedDailyReport = _dailyReports[_editDailyReportDialogueId];

  const userCanEditDailyReport = () => {
    if (selectedDailyReport === null) return false;
    if (selectedDailyReport.isPublished === true) return false;
    return SiteboardApiValidator[ADD_DAILY_REPORT].isUserIdAuthorized(_userId, selectedSubscription, selectedProject); // TODO: change this to EDIT_DAILY_REPORT
  }
  const userCanDeleteDailyReport = () => {
    if (selectedDailyReport === null) return false;
    if (selectedDailyReport.isPublished === true) return false;
    return SiteboardApiValidator[DELETE_DAILY_REPORT].isUserIdAuthorized(_userId, selectedSubscription, selectedProject);
  };

  const closeDialogue = () => {
    siteboardAction(SET_EDIT_DAILY_REPORT_DIALOGUE_ID, { dailyReportId: '00000000-0000-0000-0000-000000000000' });
  };

  //<PopupWindow title={`Daily Report - ${selectedDailyReport.date} (${selectedDailyReport.isPublished === true ? 'Published' : 'Draft'})`} closeDialogue={closeDialogue} bgStyle='bg-[#333333]'>
  return (
    <PopupWindow title={'Edit Daily Report'} closeDialogue={closeDialogue} bgStyle='bg-[#333333]'>
      <div className={'flex flex-col w-full h-full overflow-y-auto'}>
        <div className={'grow flex min-h-0'}>
          <div className='flex flex-col grow'>
            {/* main area */}
            {!selectedDailyReport &&
              <div className='grow flex flex-col justify-center gap-y-1 p-1'>
                <div className='flex rounded-[10px] py-6 px-10 items-center justify-center font-semibold text-white text-[1.5em] gap-x-4'>
                  <div className='animate-[spin_1s_linear_infinite]'>
                    <Logo size={48} />
                  </div>
                  <p className='select-none'>Loading Daily Report</p>
                </div>
              </div>
            }
            {selectedDailyReport &&
              <div className='flex flex-col gap-y-3 text-white'>
                {/* header */}
                <div className='text-center text-[1.4em] font-bold whitespace-nowrap'>
                  Daily Report - {selectedDailyReport.date} ({selectedDailyReport.isPublished === true ? 'Published' : 'Draft'})
                </div>
                <div className='grow flex gap-x-[50px] bg-[#333]'>
                  <div className='w-1/2 flex flex-col ustify-start items-start gap-y-10 p-1'>
                    <div className='flex gap-x-2'>
                      <div className={'justify-self-end font-medium text-right h-[1.6em] ' + (false ? 'text-[#f12035]' : '')}><p className='leading-5'>Assignee</p></div>
                      <input 
                        className={'w-full h-full px-2 rounded-[5px] outline-none bg-[#444247] hover:bg-[#656565] focus:bg-[#656565]'}
                        type='text' 
                        disabled={!userCanEditDailyReport()}
                        value={selectedDailyReport.assignee}
                        onChange={(event) => {}}
                       />
                    </div>
                    <div className='flex gap-x-2'>
                      <input 
                        className='w-[1.2em] h-[1.2em]' 
                        type='checkbox' 
                        checked={selectedDailyReport.hasDelays === true} 
                        onChange={() => {}}
                      />
                      <div className={'justify-self-end font-medium text-right h-[1.6em] ' + (false ? 'text-[#f12035]' : '')}><p className='leading-5'>Delays?</p></div>
                    </div>
                    {selectedDailyReport.hasDelays === true && 
                      <div className='grow flex flex-col max-w-[700px]'>
                        <textarea 
                          className={'h-[5.2em] sm:h-[6.8em] leading-[1.1em] p-1 resize-none font-medium bg-[#444247] hover:bg-[#656565] focus:bg-[#656565] outline-none'}
                          value={selectedDailyReport.delayNotes}
                          disabled={userCanEditDailyReport() !== true}
                          placeholder='Delay Notes'
                          onChange={(event) => {
                            //editSchedule({
                            //  ...selectedSchedule,
                            //  generalNotes: event.target.value,
                            //});
                          }}
                        >
                        </textarea>
                      </div>
                    }
                    <div className='flex gap-x-2'>
                      <input 
                        className='w-[1.2em] h-[1.2em]' 
                        type='checkbox' 
                        checked={selectedDailyReport.hasInspections === true} 
                        onChange={() => {}}
                      />
                      <div className={'justify-self-end font-medium text-right h-[1.6em] ' + (false ? 'text-[#f12035]' : '')}><p className='leading-5'>Inspections?</p></div>
                    </div>
                    {selectedDailyReport.hasInspections === true && 
                      <div className='grow flex flex-col max-w-[700px]'>
                        <textarea 
                          className={'h-[5.2em] sm:h-[6.8em] leading-[1.1em] p-1 resize-none font-medium bg-[#444247] hover:bg-[#656565] focus:bg-[#656565] outline-none'}
                          value={selectedDailyReport.inspectionNotes}
                          disabled={userCanEditDailyReport() !== true}
                          placeholder='Inspection Notes'
                          onChange={(event) => {
                            //editSchedule({
                            //  ...selectedSchedule,
                            //  generalNotes: event.target.value,
                            //});
                          }}
                        >
                        </textarea>
                      </div>
                    }
                    <div className='grow flex flex-col max-w-[700px]'>
                      <div className=''>General Notes</div>
                      <textarea 
                        className={'h-[5.2em] sm:h-[6.8em] leading-[1.1em] p-1 resize-none font-medium bg-[#444247] hover:bg-[#656565] focus:bg-[#656565] outline-none'}
                        value={selectedDailyReport.generalNotes}
                        disabled={userCanEditDailyReport() !== true}
                        onChange={(event) => {
                          //editSchedule({
                          //  ...selectedSchedule,
                          //  generalNotes: event.target.value,
                          //});
                        }}
                      >
                      </textarea>
                    </div>
                    {/* Upload picture button */}
                    <div className='grow flex flex-col gap-y-2'>
                      <div className='text-[1.2em] font-bold'>Worksite Pictures</div>
                        <div className='flex gap-x-1'>
                        {worksitePicturesData.map((imageObject, index) => (
                          <div key={index} className='flex flex-col' >
                            <img  className='rounded-[5px]' src={imageObject.imageData} alt={imageObject.name} title={imageObject.name} />
                          </div>
                        ))}
                        </div>
                      <input 
                        ref={uploadWorksiteImageInputRef}
                        className='hidden'
                        type='file' 
                        multiple
                        id='worksitePictureInput' 
                        accept='image/*' 
                        onChange={(event) => {
                          const files = uploadWorksiteImageInputRef.current.files;
                          if(!isObject(files)) return;
                          if(!isObject(files[0])) return;
                          const file = files[0];
                          const reader = new FileReader();
                          reader.onload = function (event) {
                            const imageData = event.target.result;
                            const image = new Image();
                            image.onload = function () {
                              const maxThumbnailSize = 128;
                              if(image.width > maxThumbnailSize || image.height > maxThumbnailSize) {
                                // scale the image down so that it its largest dimension does not exceed maxThumbnailSize
                                const scaleX = maxThumbnailSize / image.width;
                                const scaleY = maxThumbnailSize / image.height;
                                const scale = Math.min(scaleX, scaleY);
                                const newImageWidth = image.width*scale;
                                const newImageHeight = image.height*scale;
                                const canvas = document.createElement('canvas');
                                canvas.width = newImageWidth;
                                canvas.height = newImageHeight;
                                const ctx = canvas.getContext('2d');
                                ctx.clearRect(0, 0, newImageWidth, newImageHeight);
                                ctx.drawImage(image, 0, 0, newImageWidth, newImageHeight);
                                const thumbnailImageData = canvas.toDataURL(file.type || 'image/png');
                                setWorksitePicturesData([...worksitePicturesData, { name: file.name, imageData: thumbnailImageData}]);
                              } else {
                                setWorksitePicturesData([...worksitePicturesData, { name: file.name, imageData: imageData}]);
                              }

                              const onSuccess = (validOutput) => {
                                console.log('response', validOutput);
                                // upload image and thumbnail
                                // NOTIFY_UPLOADED_DAILY_REPORT_IMAGE to tell server we uploaded the images
                              };
                              siteboardAction(REQUEST_UPLOAD_DAILY_REPORT_IMAGE, { 
                                projectId: selectedProject.id,
                                dailyReportId: _editDailyReportDialogueId,
                                imageName: file.name,
                              }, onSuccess);
                            };
                            image.src = imageData;
                          };
                          reader.readAsDataURL(file);
                        }}
                      />
                      <div>
                        <button  
                          className='flex items-center bg-[#471cff] hover:bg-[#603aff] py-[9px] px-[15px] text-white font-bold select-none rounded-[10px] gap-x-[5px] sm:gap-x-[12px] whitespace-nowrap' 
                          onClick={() => {
                            uploadWorksiteImageInputRef.current.click();
                          }}
                        >
                          <ExportIcon color='#fff' />
                          <p>Upload Picture(s)</p>
                        </button>
                      </div>
                    </div>
                    {/* Upload file button */}
                    <div className='grow flex flex-col'>
                      <div className='text-[1.2em] font-bold'>Files</div>
                      <button  
                        className='flex items-center bg-[#471cff] hover:bg-[#603aff] py-[9px] px-[15px] text-white font-bold select-none rounded-[10px] gap-x-[5px] sm:gap-x-[12px] whitespace-nowrap' 
                        onClick={() => {
                        }}
                      >
                        <ExportIcon color='#fff' />
                        <p>Upload File</p>
                      </button>
                    </div>
                    {/* delete schedule button */}
                    {userCanDeleteDailyReport() &&
                      <button
                        className='flex items-center gap-x-[5px] sm:gap-x-[12px] text-white bg-[#cc1b2d] hover:bg-[#f12035] font-semibold select-none ml-1 py-[10px] px-[10px] whitespace-nowrap rounded-[10px]'
                        onClick={() => { siteboardAction(SET_DELETE_DAILY_REPORT_DIALOGUE_ID, { dailyReportId: _editDailyReportDialogueId }); }}
                      >
                        <TrashIcon color='#fff' />
                        <p className=''>Delete Daily Report</p>
                      </button>
                    }
                  </div>
                  <div className='w-1/2 p-1'>
                    <div className='w-full text-center text-[1.4em] text-[#f9a928] font-bold'>
                      Worklog
                    </div>
                    {/* Edit Contractor List button  */}
                    <button
                      className='flex items-center bg-[#a29c9c] hover:bg-[#efe4e4] text-black font-semibold select-none py-[6px] px-[5px] sm:px-[10px] gap-x-[5px] sm:gap-x-[12px] whitespace-nowrap'
                      onClick={() => {
                        siteboardAction(SET_EDIT_CONTRACTORS_DIALOGUE_ID, {projectId: selectedProject.id});
                      }}
                    >
                      <SettingsIcon color='#444247' />
                      <p className=''>Edit Contractor List</p>
                    </button>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </PopupWindow>
  );
}

const mapStateToProps = state => { return { // define redux state that will be passed in as props
  _userId: state.localPersistent.userId,
  _projects: state.serverSynced.projects,
  _subscriptions: state.serverSynced.subscriptions,
  _dailyReports: state.serverSynced.dailyReports,
  _dailyReportSummaries: state.serverSynced.dailyReportSummaries,
  _editDailyReportDialogueId: state.localEphemeral.editDailyReportDialogueId,
}};
export default connect(mapStateToProps, {siteboardAction})(EditDailyReportDialogue);
